var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { ProductPreview } from '../../components/ProductPreview';
import { FontLoader } from './FontLoader';
export class FontEditor {
    constructor(htmlElement, target) {
        this.fontElements = [];
        this.styles = {};
        this.textPanelDefaultParameters = {
            lineHeight: 0,
            fontSize: 0
        };
        this.variables = {};
        this.htmlElement = $(htmlElement);
        this.htmlEditor = this.htmlElement.find('div[contenteditable]');
        this.productID = parseInt(this.htmlElement.data('id'));
        this.defaultColor = this.htmlElement.data('defaultColor');
        this.fontName = this.htmlElement.data('fontName');
        this.target = target;
        this.fontElements.push(this.htmlEditor);
        this.htmlElement.find('.panel:not(.panel-about) .content').each((panel) => {
            this.fontElements.push(panel);
        });
        this.htmlElement.find('.dropdown-weight a').forEach((item) => {
            this.styles[$(item).data('value')] = false;
        });
        this.setColor(this.defaultColor);
        this.setupEvents();
        this.fixLayout();
        /*if (this.target === 'preview' || this.target === 'about' || this.target === 'charset') {
          this.htmlElement.find('.button-open-charset, .button-open-preview, .button-open-about, .button-open-charset').removeClass('button-active');
          this.htmlElement.find('.panel-tester, .panel-about, .panel-charset').addClass('d-none');
    
          $('.button-open-' + this.target).addClass('button-active');
    
          if (this.target == 'preview') this.htmlElement.find('.panel-tester').removeClass('d-none').addClass('is-blured');
          if (this.target == 'about') this.htmlElement.find('.panel-about').removeClass('d-none');
          if (this.target == 'charset') this.htmlElement.find('.panel-charset').removeClass('d-none').addClass('is-blured');
        }*/
        if (this.target === 'preview')
            this.htmlElement.find('.button-open-preview').trigger('click');
        if (this.target === 'charset')
            this.htmlElement.find('.button-open-charset').trigger('click');
        if (this.target === 'about')
            this.htmlElement.find('.button-open-about').trigger('click');
        let selectedStyleButton = this.htmlElement.find('.dropdown-weight a.color-gray');
        this.setStyle(selectedStyleButton.data('value'), selectedStyleButton.data('features'));
    }
    setupEvents() {
        $(document).on('resize', () => {
            this.fixLayout();
        });
        /*this.htmlEditor.on('keyup', (event: KeyboardEvent, editor: Collection) => {
          const savedSelection = saveSelection();
    
          editor.html(editor.html().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    
          restoreSelection(savedSelection, true);
        });*/
        this.htmlElement.find('.button-open-preview').on('click', (event, button) => {
            event.preventDefault();
            this.htmlElement.find('.button-open-about, .button-open-charset').removeClass('button-active');
            this.htmlElement.find('.panel-charset').addClass('d-none');
            this.htmlElement.find('.panel-about').addClass('d-none');
            $(button).addClass('button-active');
            this.htmlElement.find('.panel-tester').removeClass('d-none').removeClass('is-blured');
        });
        this.htmlElement.find('.button-open-about').on('click', (event, button) => {
            event.preventDefault();
            button.toggleClass('button-active');
            this.htmlElement.find('.button-open-preview, .button-open-charset').removeClass('button-active');
            this.htmlElement.find('.panel-about').removeClass('d-none');
            this.htmlElement.find('.panel-tester, .panel-charset').addClass('is-blured');
            this.htmlElement.find('.mobile-options').addClass('is-blured');
            if ($(window).width() < 992)
                $.scrollTo(this.htmlElement.position().y);
        });
        this.htmlElement.find('.btn-close-about').on('click', (event, button) => {
            event.preventDefault();
            button.toggleClass('button-active');
            this.htmlElement.find('.panel-about').addClass('d-none');
            this.htmlElement.find('.panel-tester, .panel-charset').removeClass('is-blured');
        });
        this.htmlElement.find('.button-open-charset').on('click', (event, button) => {
            event.preventDefault();
            this.htmlElement.find('.button-open-preview, .button-open-about').removeClass('button-active');
            this.htmlElement.find('.panel-tester').addClass('d-none');
            this.htmlElement.find('.panel-about').addClass('d-none');
            $(button).addClass('button-active');
            this.htmlElement.find('.panel-charset').removeClass('d-none').removeClass('is-blured');
            ;
        });
        this.htmlElement.find('.slider-size').on('input', (event, slider) => {
            this.fontElements.forEach((item) => {
                let sliderValue = parseFloat(slider.val());
                let fontSize = ($(window).width() < 768) ? 15 : 7.5;
                if (item.hasClass('contenteditable')) {
                    item.css('font-size', (fontSize + sliderValue) + 'vw');
                }
            });
        }).on('change', () => {
            this.focus();
        });
        this.htmlElement.find('.slider-variable').each((slider) => {
            const key = $(slider).data('key');
            this.variables[key] = parseFloat(slider.val());
            this.updateVariable();
        }).on('input', (event, slider) => {
            this.fontElements.forEach((item) => {
                const sliderValue = parseFloat(slider.val());
                const key = $(slider).data('key');
                this.variables[key] = sliderValue;
                this.updateVariable();
            });
        }).on('change', () => {
            this.focus();
        });
        this.htmlElement.find('.button-toggle-color').on('click', (event, button) => {
            event.preventDefault();
            $(button).toggleClass('active');
            this.setColor((this.htmlEditor.get(0).style.color == 'rgb(0, 0, 0)') ? this.defaultColor : '#000');
        });
        this.htmlElement.find('.button-align-left').on('click', (event, button) => {
            event.preventDefault();
            $(button).addClass('active');
            this.htmlElement.find('.button-align-center').removeClass('active');
            this.setAlign('left');
        });
        this.htmlElement.find('.button-align-center').on('click', (event, button) => {
            event.preventDefault();
            $(button).addClass('active');
            this.htmlElement.find('.button-align-left').removeClass('active');
            this.setAlign('center');
        });
        this.htmlElement.find('.select-features').on('change', (event, button) => {
            this.setStyle($(button).val(), button.find('option:checked').data('features'));
        });
        this.htmlElement.find('.dropdown-weight a').on('click', (event, button) => {
            event.preventDefault();
            this.htmlElement.find('.dropdown-weight a').removeClass('color-gray').addClass('color-black');
            $(button).removeClass('color-black').addClass('color-gray');
            this.setStyle($(button).data('value'), button.data('features'));
        });
        this.htmlElement.find('.dropdown-features a, .features-list a').on('click', (event, button) => {
            event.preventDefault();
            $(button).toggleClass('color-black color-gray');
            this.setFeatures(this.htmlElement.find('.dropdown-features a.color-gray'));
            /*const wasActive = ($(button).hasClass('color-black')) ? true : false;
      
            this.htmlElement.find('.dropdown-features a, .features-list a').removeClass('color-black').addClass('color-gray');
      
            if (wasActive) {
            } else {
              $(button).removeClass('color-gray').addClass('color-black');
            }
      
            if (wasActive) {
              this.setFeatures();
            } else {
              this.setFeatures($(button).data('key'));
            }*/
        });
    }
    loadStyle(styleName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading(true);
            yield FontLoader.load(this.productID, this.fontName, styleName);
        });
    }
    loading(show) {
        if (show) {
            this.htmlElement.find('.loading-indicator').removeClass('d-none');
        }
        else {
            this.htmlElement.find('.loading-indicator').addClass('d-none');
        }
        this.fontElements.forEach((item) => {
            if (show) {
                $(item).addClass('loading');
            }
            else {
                $(item).removeClass('loading');
            }
        });
    }
    setFeatures(items) {
        let featureKeys = [];
        if (items) {
            items.each((item) => {
                featureKeys.push('"' + item.data('key') + '"');
            });
        }
        this.fontElements.forEach((item) => {
            if (featureKeys.length == 0) {
                item.get(0).style.removeProperty('font-feature-settings');
            }
            else {
                console.log('x', featureKeys);
                item.get(0).style.setProperty('font-feature-settings', featureKeys.join(','));
                //item.get(0).style.setProperty('font-feature-settings', ['"calt"', '"liga"', '"dlig"', ...featureKeys].join(','));
            }
        });
        this.focus();
    }
    setStyle(name, availableFeatures) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.styles[name])
                yield this.loadStyle(name);
            this.fontElements.forEach((item) => {
                item.css('font-family', this.fontName + '_' + name);
            });
            this.loading(false);
            this.focus();
            this.updateFeature(availableFeatures.split(','));
            if (name === 'variable') {
                $('.variable-panel').removeClass('d-none');
            }
            else {
                $('.variable-panel').addClass('d-none');
            }
        });
    }
    setColor(color) {
        this.fontElements.forEach((item) => {
            item.css('color', color);
        });
        this.focus();
    }
    setAlign(align) {
        this.fontElements.forEach((item) => {
            item.css('text-align', align, 'important');
        });
        this.focus();
    }
    focus() {
        this.htmlEditor.get(0).focus();
    }
    fixLayout() {
        ProductPreview.setDropdownFeaturesPosition();
        setTimeout(() => {
            ProductPreview.setDropdownFeaturesPosition();
        }, 100);
        setTimeout(() => {
            ProductPreview.setDropdownFeaturesPosition();
        }, 2000);
        let minHeight = 0;
        if ($(window).width() < 767) {
            minHeight = $(window).height() - this.htmlElement.find('.mobile-options').height() - this.htmlElement.find('.row-title').height() - $('header').height();
        }
        else {
            minHeight = (this.htmlElement.width() - (parseInt(this.htmlElement.css('padding-left')) * 2)) / 2.54000508;
        }
        this.htmlElement.find('.panel').css('min-height', minHeight + 'px');
    }
    updateFeature(availableFeatures) {
        $('.dropdown-features a, .features-list a').each((button) => {
            //button.removeClass('color-gray').addClass('color-black');
            if (availableFeatures.indexOf(button.data('key')) != -1) {
                button.removeClass('d-none');
            }
            else {
                button.addClass('d-none');
            }
        });
        this.setFeatures();
    }
    updateVariable() {
        let variables = [];
        for (const key in this.variables) {
            variables.push('"' + key + '"' + this.variables[key]);
        }
        this.fontElements.forEach((item) => {
            item.css('font-variation-settings', variables.join(','));
        });
    }
}
